import { render, staticRenderFns } from "./dummy.vue?vue&type=template&id=4feba27d&scoped=true&"
import script from "./dummy.vue?vue&type=script&lang=js&"
export * from "./dummy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feba27d",
  null
  
)

export default component.exports